import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from '../messages';

// noinspection JSValidateTypes
export const InsuranceOptionLabel = () => <FormattedMessage {...messages.insurance} />;
